<template>
    <rkm-modal
        :buttons="['cancel']"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
        title="Parametrização de cota de laboratório"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            :cotaAno="cotaAno"
            @save="handleExit"
            @closeModal="closeModal"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from './Form'

// Mixins.
import { repository, object, data, mask, formats } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        index: null,
        item: null,
        cotaAno: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item, cotaAno) {

            this.index = index
            this.item = item
            this.cotaAno = cotaAno

            if (index == null ) {

                this.$refs.Modal.show()
            } else if (item.alterado) {

                this.$refs.Modal.show()
            } else {

                this.getCotaLaboratorio(item)
            }
        },
        handleExit(data) {
            this.$emit('save', data)
        },
        closeModal(data) {
           this.$emit('save', data)
           this.$refs.Modal.hide()
        },
        getCotaLaboratorio(item) {

            this.setLoading()

            this.repositories.parametrizacao.getCotaLaboratorio({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                ano: item.ano
            })
                .then(response => {

                    const objId = this.data.model.cotasLaboratorio.findIndex((obj =>
                        obj.infraestruturaId == item.infraestruturaId && obj.ano == item.ano));

                    this.data.model.cotasLaboratorio[objId].cotaLaboratorio = response.data
                    this.data.model.cotasLaboratorio[objId].alterado = true

                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, object, data, mask, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>